import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

export default function ManageDiscountMenu({ openItem, activeItem }) {
  return (
    <>
      <li
        className={`nav-item has-treeview 
            ${sidebarHelper.checkOpenItem(openItem, "manage-discount")} `}
      >
        <a
          href="# "
          className={`nav-link  
            ${sidebarHelper.checkActiveItem(openItem, "manage-discount")} `}
        >
          <i className="nav-icon fas fa-percent"></i>
          <p>
            تخفیف
            <i className="right fa fa-angle-left"></i>
          </p>
        </a>

        <ul className="nav nav-treeview">
          <li className="nav-item">
            <Link
              to="/manage/discount/all-type"
              className={`nav-link  
                ${sidebarHelper.checkActiveItem(
                  activeItem,
                  "all-type-discount"
                )} `}
            >
              <i className="fa fa-list nav-icon"></i>
              <p>لیست کد تخفیف</p>
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/manage/discount/select-position-banner"
              className={`nav-link  
                ${sidebarHelper.checkActiveItem(
                  activeItem,
                  "select-position-banner-discount"
                )} `}
            >
              <i className="fa fa-list nav-icon"></i>
              <p>کد تخفیف برای هر جایگاه</p>
            </Link>
          </li>
        </ul>
      </li>
    </>
  );
}
